module.exports = __webpack_public_path__ + "static/media/02.ada0bd08.webp";